/**
 * Returns how far the camera should move toward a zoom target to scale its apparent size by `scale`.
 *
 * A perspective projection scales content by the inverse of its distance, so reaching `scale` means
 * moving to `distance / scale`. The step is proportional to the distance, which keeps the gesture count
 * for approaching an object logarithmic in its distance instead of linear. `minDistance` keeps steps
 * from vanishing next to a surface. Positive values move toward the target, negative values away.
 */
export function hsComputeZoomTravel(distance: number, scale: number, minDistance: number): number {
  if (!Number.isFinite(scale) || scale <= 0 || scale === 1) {
    return 0;
  }

  const baseDistance: number = Number.isFinite(distance) ? Math.max(distance, minDistance) : minDistance;
  return baseDistance * (1 - 1 / scale);
}
